<template>
    <div class="my-progress-bar" :style="{'--context-color' : color, '--progressbar-value' : progressBarValue}">
        <div v-if="!hideHeader" class="d-flex justify-content-between">
            <div class="my-progress-bar__title">{{title}}</div>
            <div class="my-progress-bar__value">{{value}}</div>
        </div>
        <div class="my-progress-bar__container"/>
        <div v-if="showDot" class="my-progress-bar__dot"/>
    </div>
</template>

<script>
    export default {
        props: {
            maxValue: {
                type: Number,
                default: () => {
                    return 0
                }
            },

            value: {
                type: Number,
                default: () => {
                    return 0
                }
            },

            showDot: {
                type: Boolean,
                default: () => {
                    return false
                }
            },

            title: {
                type: String,
                default: () => {
                    return null
                }
            },

            color: {
                type: String,
                default: () => {
                    return null
                }
            },

            hideHeader: {
                type: Boolean,
                default: () => {
                    return false
                }
            },
        },
        computed: {
            progressBarValue() {
                let val = this.maxValue > 0 ? this.value / this.maxValue * 100 : 0

                return Math.round(val) + '%'
            }
        }
    }
</script>
<style lang="scss" scoped>
.my-progress-bar {
    position: relative;
    &.green-block {

    }
    .my-progress-bar__title {
        font-weight: 300;
        font-size: 10px;
        line-height: 20px;
        text-transform: capitalize;
        color:  var(--text-default-color);
    }
    .my-progress-bar__value {
        font-weight: 300;
        font-size: 14px;
        line-height: 20px;
        color: var(--context-color);
    }

    .my-progress-bar__container {
        margin-top: 5px;
        width: 100%;
        border-radius: 71.5px;
        height: 10px;
        position: relative;

        &::before {
            content: "";
            right: 0;
            height: 10px;
            position: absolute;
            border-radius: 71.5px;
            left: 0;
            background-color: var(--context-color);
            opacity: 0.3;
        }
        &::after {
            content: "";
            right: 0;
            width: var(--progressbar-value);
            height: 10px;
            position: absolute;
            border-radius: 71.5px;
            left: 0;
            background-color: var(--context-color);
        }
    }
    .my-progress-bar__dot {
        position: absolute;
        width: 17px;
        height: 17px;
        top:21px;
        left:calc(var(--progressbar-value) - 17px);
        border-radius: 100%;
        border:5px solid var(--context-color);
        background-color: #FFF;
    }
}
</style>
